import { AnyToggleValue } from '../types';
import { BaseToggleStrategy } from './BaseToggleStrategy';

export class DefaultToggleStrategy<R> extends BaseToggleStrategy<R> {
  public determineToggleValue(toggleValue?: ToggleValue<R>): R {
    return this.getTargetedValue(toggleValue);
  }

  public isValidToggle(toggleValue: AnyToggleValue): boolean {
    return true;
  }
}
